import { defineStore, acceptHMRUpdate } from 'pinia';
import i18n from '@/js/plugins/i18n';

const availableLanguages = ['en', 'fr'];

function getFirstBrowserLanguage() {
  const nav = window.navigator;
  const browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
  // support for HTML 5.1 "navigator.languages"
  if (_.isArray(nav.languages)) {
    for (let i = 0; i < nav.languages.length; i++) {
      const language = nav.languages[i];
      if (language && language.length) {
        return language;
      }
    }
  }
  // support for other well known properties in browsers
  for (let i = 0; i < browserLanguagePropertyKeys.length; i++) {
    const language = nav[browserLanguagePropertyKeys[i]];
    if (language && language.length) {
      return language;
    }
  }
  return null;
}

const store = defineStore('lang', {
  state: () => ({
    i18n,
    lang: i18n.global.locale,
  }),

  actions: {
    setLang(lang) {
      this.lang = lang;
      this.i18n.global.locale = lang;
      moment.locale(lang);
      window.localStorageWrapper.setItem('lang', lang);
      document.querySelector('html').setAttribute('lang', lang);
    },

    loadLang(langParam = 'en') {
      const lang = availableLanguages.includes(langParam) ? langParam : 'en';
      this.setLang(lang);
      return Promise.resolve(lang);
    },

    loadLocale(langParam = window.localStorageWrapper.getItem('lang')) {
      let lang = availableLanguages.includes(langParam) ? langParam : '';
      if (! lang) {
        const browserLanguage = (getFirstBrowserLanguage() || '').slice(0, 2);
        lang = availableLanguages.includes(browserLanguage) ? browserLanguage : '';
      }
      lang = lang || 'en';
      this.loadLang(lang);
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
